module.exports = __webpack_public_path__ + "img/italy-congenital-and-perinatal-diseases-female.87bca1f3.png";